import mix from './mix';

export default (color: string, percent: number) => mix('#000000', color, percent);
